module.exports = __webpack_public_path__ + "static/media/wellemental-logo-full.0915c94b.webp";